<div class="form-button" [formGroup]="group" [ngStyle]="field.containerStyles">
  <button
    *ngIf="field.button.layout === 'raised'"
    mat-raised-button
    [disabled]="!active"
    [ngClass]="getButtonClasses()"
    [ngStyle]="field.buttonStyles"
    [color]="field.button?.color ? field.button.color : false"
    (click)="buttonClick()"
    [innerHTML]="field.label | gioNoSanitize"></button>

    <button
    *ngIf="field.button.layout === 'basic'"
    mat-button
    [disabled]="!active"
    [ngClass]="getButtonClasses()"
    [ngStyle]="field.buttonStyles"
    [color]="field.button?.color ? field.button.color : false"
    (click)="buttonClick()"
    [innerHTML]="field.label | gioNoSanitize"></button>

    <button
    *ngIf="field.button.layout === 'flat'"
    mat-flat-button
    [disabled]="!active"
    [ngClass]="getButtonClasses()"
    [ngStyle]="field.buttonStyles"
    (click)="buttonClick()"
    [innerHTML]="field.label | gioNoSanitize"></button>

    <button
    *ngIf="field.button.layout === 'fab'"
    mat-fab
    [disabled]="!active"
    [ngClass]="getButtonClasses()"
    [color]="field.button.color"
    (click)="buttonClick()">

      <mat-icon>check</mat-icon>


   </button>
</div>
